// extracted by mini-css-extract-plugin
export default {"inputLabel":"activateModal_inputLabel__HFfe0","inputWrapper":"activateModal_inputWrapper__jWWry","helpText":"activateModal_helpText__mFoAc","form":"activateModal_form__YeFMo"};